var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doctype)?_c(_vm.doctype,_vm._b({tag:"Component",on:{"hook:mounted":_vm.triggerCludoScripts}},'Component',_vm.$data,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }